import React, { useState } from 'react';
import { login } from './apiService.js';
import { useNavigate } from 'react-router-dom';
import './login.css';

const LoginPage = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setShowPopup(true);
    try {
      const credentials = { username, password };
      const response = await login(credentials);

      if (response && response.LoginToken) {
        // Save response data in localStorage
        localStorage.setItem('personalDetails', JSON.stringify(response));
        onLoginSuccess();
        setShowPopup(false);
        navigate('/home');
      } else {
        setError('Invalid response from server.');
        setShowPopup(false);
      }
    } catch (err) {
      setError('Login failed. Please check your credentials.');
      setShowPopup(false);
    } finally {
      setShowPopup(false);
    }
  };

  return (
    <>
      <div className={`mainDivLogin ${showPopup ? 'blur-background' : ''}`}>
        <div className="login-container">
          <p className="loginheading">Login To Balaji App</p>
          <form onSubmit={handleLogin}>
            <div className="input-div">
              <label>Username</label>
              <input
                type="text"
                placeholder="Enter Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="input-div">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <button type="submit">Login</button>
          </form>
        </div>
      </div>

      {showPopup && (
        <div className="popup show">
          Loading...
        </div>
      )}
    </>
  );
};

export default LoginPage;
